import type { JSX } from "react";

import {
    newReportAction,
    classificationSavedTemplatesLinkAction,
} from "../applicationBarActions";
import { ReportColumnId, REPORT_COLUMN_IDS } from "../columns";
import { ReportsListLayout } from "../layout";

/**
 * The page with classification reports (also known as task-based reports).
 */
function ReportsClassificationPage(): JSX.Element {
    return (
        <ReportsListLayout
            pageType="Classification"
            columnIds={COLUMN_IDS}
            actions={[
                classificationSavedTemplatesLinkAction(),
                newReportAction("Classification"),
            ]}
        />
    );
}

const COLUMN_IDS: Array<ReportColumnId> = [
    REPORT_COLUMN_IDS.NAME,
    REPORT_COLUMN_IDS.CLASSIFICATION,
    REPORT_COLUMN_IDS.DESCRIPTION,
    REPORT_COLUMN_IDS.PUSH_REPORTS_COUNT,
    REPORT_COLUMN_IDS.ACCESS_RIGHTS,
    REPORT_COLUMN_IDS.ACTION,
];

export { ReportsClassificationPage };
